<template>
  <div class="index_img">
    <img
      src="../../../../public/static/image/img-arrow.gif"
      class="index_img_mp"
    />
  </div>
</template>
<script>
export default {
  props: {
    src: {
      type: String,
      default: ""
    },
    height: {
      type: String,
      default: "0px"
    }
  }
};
</script>
<style scoped>
.index_img {
  /* width: 100vw; */
  text-align: center;
}
.index_img_mp {
  height: 55px;
}
</style>
